import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import mobileMenuIcon from "../../assets/img/icons/mobileMenuIcon.svg";
import logo from "../../assets/img/logo.svg";
import { useSiteData } from "../../SiteDataContext";

const Header: React.FC = () => {
  const location = useLocation();
  const { pathname } = location;
  const { siteData, setSiteData } = useSiteData();

  const { t } = useTranslation();

  return (
    <header className="w-full bg-header">
      <div className="container relative pl-1-25 md:plr-3 mx-auto w-full text-white h-3-5 md:h-5 flex md:justify-center">
        <div
          role="button"
          aria-label="Open mobile menu"
          className="w-1/5 flex h-100p cursor-pointer absolute pl-1-25 top-0 left-0 md:hidden"
          onClick={() =>
            setSiteData({ ...siteData, isOpenMobileMenuModal: true })
          }
        >
          <img
            src={mobileMenuIcon}
            className="mw-2-625 mr-3 md:w-3-5 md:mr-1"
            alt="Logo"
          />
        </div>
        <div className="md:w-1/2 flex flex-1 items-center justify-center md:justify-start">
          <div className="cursor-pointer">
            <a href="/" className="flex items-center">
              <img
                src={logo}
                className="w-56 md:w-56 mr-3 lg:w-80 md:mr-1"
                alt="Logo"
              />
              {/*
              <h3 className="uppercase italic md:lt-0-03 f-size-1-25 md:f-size-1-9 font-bold font-HelveticaNeueLTW06107XBlkCnObl">
                {t("header.name")}
              </h3>
              */}
            </a>
          </div>
        </div>
        <div className="md:w-1/2 flex hidden md:flex text-center">
          <ul className="flex items-center justify-end w-full text-lg leading-[1.3rem] gap-[1rem]">
            <li>
              <a
                className={`py-1-5 f-size-1-125 font-bold ${
                  pathname === "/about" ? "color-green" : ""
                }`}
                href="/about"
              >
                {t("header.about")}
              </a>
            </li>
            {siteData.show_dns_monitor === true && (
              <li>
                <a
                  className={`py-1-5 f-size-1-125 font-bold ${
                    pathname === "/dns-monitor" ? "color-green" : ""
                  }`}
                  href="/dns-monitor"
                >
                  {t("header.dns_monitor")}
                </a>
              </li>
            )}
            {siteData.show_statistics === true && (
              <li>
                <a
                  className={`py-1-5 f-size-1-125 font-bold ${
                    pathname === "/stat" ? "color-green" : ""
                  }`}
                  href="/stat"
                >
                  {t("header.stat")}
                </a>
              </li>
            )}
            <li>
              <a
                className={`py-1-5 f-size-1-125 font-bold ${
                  pathname === "/contacts" ? "color-green" : ""
                }`}
                href="/contacts"
              >
                {t("header.contacts")}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
